export const MOVE_ARTICLE_GROUP = 'MOVE_ARTICLE_GROUP';
export const DELETE_ARTICLE_GROUP = 'DELETE_ARTICLE_GROUP';
export const NEW_ARTICLE_GROUP = 'NEW_ARTICLE_GROUP';
export const TOGGLE_ALIGN = 'TOGGLE_ALIGN';



/** WEBPACK FOOTER **
 ** ./src/actions/articleGroup.js
 **/